module.exports = __webpack_public_path__ + "img/timeline_final.a9c9b366.jpg";